var React = require('react');

function MdLineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.99998 164.846L5 167.738L-2.15108e-05 164.846L0 -4.37114e-07L10 0L9.99998 164.846ZM9.99998 169.467L6.00136 171.78L5 172.359L3.99864 171.78L-2.17128e-05 169.467L-4.31224e-05 332L9.99996 332L9.99998 169.467Z","fill":"#E2E6EC"}));
}

MdLineInline.defaultProps = {"width":"10","height":"332","viewBox":"0 0 10 332","fill":"none"};

module.exports = MdLineInline;

MdLineInline.default = MdLineInline;
